import type { ThirdPassV2 } from '../types/watchdog';
import { AffectedProvisionsList } from './AffectedProvisionsList';
import { AbuseScenarioCard } from './AbuseScenarioCard';
import { CriticalReviewBlock } from './CriticalReviewBlock';
import { IndependentReadingPanel } from './IndependentReadingPanel';

interface Props {
  third: ThirdPassV2;
}

export function ThirdPassV2View({ third }: Props) {
  return (
    <div className="third-pass-v2">
      <AffectedProvisionsList provisions={third.affected_provisions} />

      {third.abuse_scenarios.length > 0 && (
        <section className="third-pass-v2__scenarios">
          <h4>Scenare a slaba mista k overeni</h4>
          {third.abuse_scenarios.map((s, i) => (
            <AbuseScenarioCard key={i} scenario={s} />
          ))}
        </section>
      )}

      <CriticalReviewBlock review={third.critical_review_of_prior_passes} />

      <IndependentReadingPanel summary={third.independent_reading_summary} />
    </div>
  );
}
